/* global suppliersUpdateUrl */

import React, { useState } from 'react';

import SuppliersEditForm from './SuppliersEditForm';

import Button from 'CommonComponents/Button';
import ModalHeader from 'CommonComponents/ModalHeader';

const SuppliersEditModal = (props) => {
    const [supplierIsUpdated, setSupplierIsUpdated] = useState(false);
    const [request, setRequest] = useState(false);
    const [requestFailed, setRequestFailed] = useState(false);

    const cleanStates = () => {
        setRequest(false);
        setRequestFailed(false);
        setSupplierIsUpdated(false);
    };

    const internalCloseHandler = () => {
        cleanStates();
        props.closeHandler();
    };

    const internalSuccessHandler = () => {
        cleanStates();
        props.successHandler();
    };

    const close = () => {
        if (supplierIsUpdated || requestFailed) {
            internalSuccessHandler();
        } else {
            internalCloseHandler();
        }
        props.modalElement.hide();
    };

    return (
        <div id={props.modalId} ref={props.modalRef} tabIndex="-1" aria-hidden="true" className="hidden modal__box">
            <div className="modal__container">
                <div className="modal__inner-container">
                    <ModalHeader title={$t('Edit Supplier')} close={close}></ModalHeader>
                    <div className="tw-rounded-b">
                        {Object.keys(props.supplier).length > 0 && (
                            <div className="modal__form-container">
                                <div className={!supplierIsUpdated && !requestFailed ? 'modal__form-container' : 'hidden'}>
                                    <SuppliersEditForm
                                        supplier={props.supplier}
                                        suppliersUpdateUrl={suppliersUpdateUrl}
                                        internalCloseHandler={internalCloseHandler}
                                        setSupplierIsUpdated={setSupplierIsUpdated}
                                        suppliersCreateUrl={props.suppliersCreateUrl}
                                        request={request}
                                    />
                                </div>
                                <div className={supplierIsUpdated ? 'tw-grid tw-grid-cols-1' : 'tw-grid tw-grid-cols-1 hidden'}>
                                    <label className="modal__msg modal__text-color">
                                        {$t('{{supplier_name}} updated', { supplier_name: props.supplier.name })}
                                    </label>
                                </div>
                                <div className={requestFailed ? 'tw-grid tw-grid-cols-1' : 'tw-grid tw-grid-cols-1 hidden'}>
                                    <label className="modal__msg modal__error-text-color">
                                        {$t('{{supplier_name}} could not be updated', { supplier_name: props.supplier.name })}
                                    </label>
                                </div>

                                {(supplierIsUpdated || requestFailed) && (
                                    <div className="modal__footer">
                                        <Button variant="secondary" onClick={internalSuccessHandler}>
                                            {$t('Close')}
                                        </Button>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default React.memo(SuppliersEditModal);
